/**
 *
 * CompletedSecondaryTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import CompletedIcon from 'assets/v2/CompletedIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.oceanGreenDark};
    background: ${COLORS.oceanGreenLight};
    border-color: ${COLORS.oceanGreen};
    border-radius: ${({ $borderRadius, theme }) => $borderRadius || theme.borderRadius.secondary};;

    &&& .MuiChip-icon path {
      fill: ${COLORS.oceanGreen};
    }
  }
`;

function CompletedSecondaryTag(props) {
  return <StyledTag label="Completed" icon={<CompletedIcon />} {...props} />;
}

export default memo(CompletedSecondaryTag);
